import { defineStore } from "pinia"
import { ref, type Ref } from "vue"
import type { InstructionFeedbackActivityTemplate } from "@/models/instruction-feedback-activity-template.model.ts"

export const useInstructionFeedbackActivityTemplateStore = defineStore(
  "instructionFeedbackActivityTemplateStore",
  () => {
    const instructionFeedbackActivityTemplates: Ref<InstructionFeedbackActivityTemplate[]> = ref([])
    const instructionFeedbackActivityTemplatesFetched = ref(false)

    function clearInstructionFeedbackActivityTemplates() {
      instructionFeedbackActivityTemplates.value = []
      instructionFeedbackActivityTemplatesFetched.value = false
    }

    return {
      instructionFeedbackActivityTemplates,
      instructionFeedbackActivityTemplatesFetched,
      clearInstructionFeedbackActivityTemplates
    }
  }
)
